



























































































































import Component, { mixins } from 'vue-class-component';
import axios from 'axios';
import { Prop, Watch } from 'vue-property-decorator';

import CookieMixin from '@/mixins/cookie';

import Vas from '@/components/Pages/MobileEstimate/VasItem.vue';
import SimTypeComponent from '@/components/Pages/MobileEstimate/SimTypeComponent.vue';
import Breadcrumb from '@/components/Pages/Breadcrumbs/Mobile.vue';
import Terminals from '@/components/Pages/MobileEstimate/Terminals.vue';
import FormArea from '@/components/Pages/MobileEstimate/ApplyForm.vue';

import LeadSection from '@/components/Templates/LeadSection.vue';
import Question from '@/components/Templates/Question.vue';

import Heading2 from '@/components/Atoms/Heading/Heading2.vue';
import TextLink from '@/components/Atoms/Link/TextLink.vue';
import LoadingComponent from '@/components/Atoms/Image/Loading.vue';

import UrlMixin from '@/mixins/url';

import { VasConfig } from '@/data/vasConfig';
import { MobileConfig } from '@/data/mobileConfig';
import FooterComponent from '@/components/Templates/Footer.vue';
import UnorderedList from '@/components/Atoms/List/UnorderedList.vue';

const vasConfig = new VasConfig();

@Component({
  components: {
    UnorderedList,
    FooterComponent,
    FormArea,
    Vas,
    SimTypeComponent,
    Terminals,
    Breadcrumb,
    LeadSection,
    Question,
    Heading2,
    TextLink,
    LoadingComponent,
  },
})
export default class Mobile extends mixins(UrlMixin, CookieMixin) {
  private vas: VasConfig = vasConfig;
  private mobile: any;
  private loading: boolean = true;
  private isApiError: boolean = false;
  private detailShow: { [key: string]: boolean } = {};

  created() {
    axios
      .get(`${this.manageBaseUrl}/no_auth/estimate/setting`)
      .then(response => {
        this.mobile = new MobileConfig(response.data);
        this.$store.commit('mobile/initialize', this.mobile);
      })
      .catch(() => (this.isApiError = true))
      .finally(() => (this.loading = false));
    this.detailShow = this.findHash(this.payload);
  }

  mounted() {
    const params = new URLSearchParams(location.search);
    const keepValue = params.get('keep');
  }

  get pageTitle() {
    return '2分でかんたん！Webでお見積り書作成';
  }

  get payload() {
    return { id: 'detailShow' };
  }

  @Watch('detailShow')
  onDetailShowChanged(
    newVal: { [key: string]: boolean },
    oldVal: { [key: string]: boolean }
  ) {
    this.saveValue(this.payload, JSON.stringify(newVal));
  }
}
